import React from 'react'
import Feature from '../Components/Feature'
import Phone from '../Components/Phone'
import Cardrs from '../Components/Cardrs';


const Products = () => {
  return (
    <div className='product-container'>
     
     <h2 className='hehe'>Products</h2>
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
        <Cardrs/>
      <Feature/>
      <Phone/>
    </div>
  )
}

export default Products